<template>
  <div class="listButton">
    <svg
      width="50"
      height="50"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        :d="path"
      />
    </svg>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ListButton",
  props: {
    icon: {
      type: String,
      default: "list",
    },
  },
  computed: {
    path() {
      if (this.icon === "list") {
        return "M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z";
      } else {
        return "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
      }
    },
  },
});
</script>

<style>
.listButton {
  position: fixed;
  background-color: #272727;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 1;
  bottom: 100px;
  right: 32px;
  color: white;
}
svg {
  margin-top: 12px;
}
</style>